import React, { useState, useEffect } from "react";
import { HashLoader } from "react-spinners";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import Box from "@mui/material/Box";

import { ICONS } from "../../utils/icons";
import { COLORS } from "../../utils/colors";
import { getAnsweredQuestions } from "../../api/tickets";

export default function FromQuestions({
  event,
  userData,
  handleSnackbar,
  dayPeriod,
}) {
  const [loading, setLoading] = useState(false);
  const [questionsObject, setQuestionsObject] = useState(null);

  const columns = event.form_questions_anonymous
    ? [
        { headerName: "Question", field: "title", flex: 1 },
        {
          headerName: "Type",
          field: "question_type",
          flex: 1,
        },
        { headerName: "Possible answers", field: "options", flex: 1 },
        { headerName: "Required", field: "required", flex: 1 },
        { headerName: "Answer", field: "answer", flex: 1 },
      ]
    : [
        { headerName: "Question", field: "title", flex: 1 },
        {
          headerName: "Type",
          field: "question_type",
          flex: 1,
        },
        { headerName: "Possible answers", field: "options", flex: 1 },
        { headerName: "Required", field: "required", flex: 1 },
        { headerName: "Answer", field: "answer", flex: 1 },
        { headerName: "Customer", field: "customer_email", flex: 1 },
      ];

  useEffect(async () => {
    try {
      setLoading(true);

      /**
       * Fetch answered questions
       */
      const { data, error, status } = await getAnsweredQuestions({
        eventID: event._id,
        apiKey: userData.operators[0].api_key,
        dayPeriod,
      });

      if (error) {
        console.log(error);
        if (!error.message.includes("No customer found")) {
          handleSnackbar(error.message, "error");
        }
        setLoading(false);
        return;
      }

      if (status === 200) {
        const combinedArray = data.flatMap((item1) => {
          const formQuestions = Array.isArray(item1.form_questions)
            ? item1.form_questions
            : [];

          return formQuestions
            .map((question) => {
              const matchingItem = event.form_questions.find(
                (item2) => question.question_id === item2._id
              );

              /**
               * Show the question even though there are no matching items because the question was answered but maybe it was deleted from the event
               */
              return {
                answer: question.answer,
                options: matchingItem?.options || "N/A",
                question_id: question.question_id,
                question_type: matchingItem?.question_type || "N/A",
                required:
                  matchingItem?.required !== true &&
                  matchingItem?.required !== false
                    ? "N/A"
                    : matchingItem?.required,
                title: matchingItem?.title || "N/A",
                ticket_id: item1.ticket_id,
                customer_email: item1.customer_email,
                customer_id: item1.customer_id,
              };
            })
            .filter((item) => item !== null); // Remove any null entries
        });

        processDataGridData(combinedArray);
      }

      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  }, []);

  const processDataGridData = (data) => {
    const array = [];

    data.forEach((customer, index) => {
      const customerData = {
        ...customer,
        index: index + 1,
        id: Math.random() * 1000,
      };

      array.push(customerData);
    });

    setQuestionsObject({
      columns: columns,
      rows: array,
    });
  };

  return (
    <div>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(3, 1fr)",
          gap: "15px",
          margin: "25px 0px",
        }}
      >
        <div className="small-container">
          <div
            className="container-row"
            style={{
              width: "-webkit-fill-container",
              justifyContent: "space-between",
            }}
          >
            <p id="subheader">Number of questions</p>
            {ICONS.questionAccent20}
          </div>
          <h2 style={{ fontSize: "34px", margin: "10px 0 0 0" }}>
            {event?.form_questions?.length}
          </h2>
        </div>
        <div className="small-container">
          <div
            className="container-row"
            style={{
              width: "-webkit-fill-container",
              justifyContent: "space-between",
            }}
          >
            <p id="subheader">Number of required questions</p>
            {ICONS.scaleAccent20}
          </div>
          <h2 style={{ fontSize: "34px", margin: "10px 0 0 0" }}>
            {event?.form_questions?.filter((q) => q.required).length}
          </h2>
        </div>
        <div className="small-container">
          <div
            className="container-row"
            style={{
              width: "-webkit-fill-container",
              justifyContent: "space-between",
            }}
          >
            <p id="subheader">Number of answers</p>
            {ICONS.peopleArrowsAccent20}
          </div>
          <h2 style={{ fontSize: "34px", margin: "10px 0 0 0" }}>
            {questionsObject?.rows.length}
          </h2>
        </div>
      </div>

      {loading && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "300px",
          }}
        >
          <HashLoader color={COLORS.mainAccent} />
        </div>
      )}

      <div style={{ maxWidth: window.innerWidth - 295 }}>
        {questionsObject && (
          <Box sx={{ height: 720, width: "100%" }}>
            <DataGrid
              {...questionsObject}
              slots={{ toolbar: GridToolbar }}
              //   onCellClick={(e) => handleClick(e.row)}
              slotProps={{
                columnMenu: {
                  background: "red",
                  counter: questionsObject.rows.length,
                },
              }}
              style={{ fontFamily: "AuthenticSans90", marginBottom: "40px" }}
              sx={{
                "& .MuiDataGrid-toolbarContainer": {
                  "& .MuiButton-text": {
                    color: COLORS.mainAccent,
                    textTransform: "capitalize",
                    fontFamily: "AuthenticSans90",
                    fontSize: "14px",
                  },
                },
              }}
            />
          </Box>
        )}
        <div style={{ height: "50px" }} />
      </div>
    </div>
  );
}
